export enum EndpointsAddress {
  Poblacions = "/geo/zipcode/:zipcode/",
  Provincies = "/geo/provincies/:ine/",
  Tipovias = "/geo/tipovias/"
}
